<div id="main-nav" class="sticky top-0 z-50 w-100 flex-col">
  @if (displayTopBar) {
    <lpcr-topbar />
  }
  <nav id="nav" class="navbar--main-navbar h-16 justify-between flex">
    <div id="left-nav" class="flex flex-row justify-center items-center lg:w-1/5">
      <!-- Logo -->
      <a href="/" title="Page d'accueil" class="flex flex-col">
        <img src="assets/img/logo.svg" alt class="px-3 h-28 lg:h-full lg:mt-7 w-28 lg:w-auto">
        <img src="assets/img/logo-shape.svg" alt class="hidden absolute top-auto bottom-0 -z-10 mt-0 -mb-9 lg:block">
      </a>
    </div>

    <!-- Menu items -->
    <div id="nav-list-container" class="lg:flex hidden h-full lg:w-3/5">
      <div id="nav-container" class="lg:flex hidden w-full h-full px-12">
        <ul role="list" class="navmenu flex mb-0 pl-0 list-none flex-1 justify-around">
          <ng-content *ngTemplateOutlet="itemsTemplate"></ng-content>
        </ul>
      </div>
    </div>
    <div class="lg:hidden flex flex-grow h-full items-center">
      <lpcr-environment-badge />
    </div>

    <!-- Right nav -->
    <div class="hidden lg:flex h-full items-center justify-end lg:w-1/5 mr-4">
      <lpcr-environment-badge />
      <ng-content *ngTemplateOutlet="rightItemTemplate"></ng-content>
    </div>

    <!-- Mobile support -->
    @if (displayMobileMenu) {
      <div class="flex items-center mx-4 h-full lg:hidden">
        <input type="checkbox" id="menu-trigger" hidden [checked]="isMenuOpen" (change)="toggleMenu()" />
        <label class="mobile-menu-icon transition-all" for="menu-trigger"></label>
        <!-- Mobile drawer aside -->
        <aside id="mobile-sidebar"
          class="fixed overflow-hidden top-16 z-10 inset-0 bg-white transform ease-in-out transition-all w-screen left-0 lg:hidden mobile-menu-sidebar">
          <section class="relative w-screen flex flex-col space-y-6 overflow-y-scroll h-full">
            <ul class="px-10 pt-5 flex-grow" role="list">
              <ng-content *ngTemplateOutlet="itemsTemplate"></ng-content>
            </ul>
            <div class="flex flex-col-reverse justify-end">
              <ng-content *ngTemplateOutlet="rightItemTemplate"></ng-content>
            </div>
          </section>
        </aside>
      </div>
    }
  </nav>
</div>
